import React from 'react';
import BagFeeBalanceIcon from "../../../icons/BagFeeBalanceIcon";
import {IconSize} from "../../../services/IconConstants";

interface Props {
    bagCount: number
    price: string
    selected: boolean
    discount?: number
    onClick: () => void
}

const PurchaseOptionProduct = ({bagCount, price, selected, discount, onClick}: Props) => {
    return (
        <>
            <div className={`purchaseOptionProduct ${selected ? 'selected' : ''} ${discount ? 'discounted' : ''}`} onClick={onClick}>
                <div className={"purchaseOptionProduct_content"}>
                    <div>
                        <BagFeeBalanceIcon size={IconSize.lg} />
                    </div>
                    <div>
                        <p className={"purchaseOptionProduct_bagCount"}>{bagCount}</p>
                        <p className={"purchaseOptionProduct_price"}>{price}</p>
                    </div>
                </div>

                {discount && <div className={"purchaseOptionProduct_discountBar"}>
                    <p>{discount}% Discount</p>
                </div>}
            </div>
        </>
    )
}

export default PurchaseOptionProduct;